import logoUrl from './FI-logo.svg';

document.querySelectorAll( '.wp-block-feld-institut-field' ).forEach( ( root ) => {
	const mark = root.querySelector( '.feld-loader-mark' );
	if ( mark ) {
		mark.innerHTML = `<img src="${ logoUrl }" alt="FI" /><p>FELD INSTITUT INTERNATIONAL</p>`;
	}

	window.setTimeout( () => root.remove(), 4200 );
} );
